import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from '@pascal/pascal-core';

import { globalTranslationKeys } from '../../../enums';
import { gameStore, roundTimeStore } from '../../../store';
import { GAME_FULL_RANGE_RULER_COUNT } from '../../../helpers/constants';
import hexagonBlue from '../../../assets/images/game/monti-polygon-blue.png';
import hexagonPurple from '../../../assets/images/game/monti-polygon-purple.png';

const RoundResultHexagon = observer(() => {
  const { finishedResult, isBetsClosed } = gameStore;
  const { passedSeconds } = roundTimeStore;
  const { time } = roundTimeStore;
  const t = useTranslation();

  const numbersRulerList = useMemo(() => {
    if (finishedResult > 0) {
      return GAME_FULL_RANGE_RULER_COUNT.slice(0, finishedResult);
    }
    if (finishedResult === 0) {
      return [0];
    }
    return [];
  }, [finishedResult]);

  return isBetsClosed && !time ? (
    <div className='monti-hexagon-structure'>
      <div className='monti-game-hexagon-holder'>
        <div className='monti-game-hexagon'>
          <img className='monti-game-hexagon blue' src={hexagonBlue} alt='' />
          <img className='monti-game-hexagon purple' src={hexagonPurple} alt='' />
        </div>
        <div className='monti-num-spinner-holder'>
          <div className='monti-num-spinner-inside'>
            <div
              className={`monti-spinner-nums ${numbersRulerList.length ? 'active' : ''}`}
              style={{ animationDuration: '2s', animationDelay: `${passedSeconds}s` }}
            >
              <div className='monti-spinner-num' key='GO'>
                {t(globalTranslationKeys.GO)}
              </div>
              {numbersRulerList.length ? (
                numbersRulerList.map((item) => (
                  <div className='monti-spinner-num' key={item}>
                    {item}
                  </div>
                ))
              ) : (
                <></>
              )}
              {finishedResult ? <div className='monti-spinner-num'>{finishedResult}</div> : <></>}
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
});

export default RoundResultHexagon;
